import { z } from 'zod';
import { emailValidation, nameValidation } from '../../../validation';

// The Vitality case manager handling the member's claim, as typed into the
// form's "Case manager" section. Not the referral's referrer: a Vitality
// referral has none (PPL-4211)
export const ReferralVitalityCaseManagerSchema = z.object({
  email: emailValidation('Case manager email is required'),
  firstname: nameValidation('Case manager first name is required'),
  lastname: nameValidation('Case manager surname is required'),
});

export type ReferralVitalityCaseManager = z.infer<
  typeof ReferralVitalityCaseManagerSchema
>;
